import { render } from "./defaultWithMenuAndToolbarLayout.vue?vue&type=template&id=442b17e6"
import script from "./defaultWithMenuAndToolbarLayout.vue?vue&type=script&lang=js"
export * from "./defaultWithMenuAndToolbarLayout.vue?vue&type=script&lang=js"

import "./defaultWithMenuAndToolbarLayout.vue?vue&type=style&index=0&id=442b17e6&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__